import { render, staticRenderFns } from "./riversoft.vue?vue&type=template&id=fbfd4004&"
import script from "./riversoft.vue?vue&type=script&lang=js&"
export * from "./riversoft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports